module.exports = __webpack_public_path__ + "static/media/0327_IMG_LE_SOL_MEGALITH_MEGABROWN.899ec831.png";